module.exports = __webpack_public_path__ + "static/media/noun-temperature-3208741.034e891f.svg";